<section class="contact" [id]="contact.id">
  <div class="container">
    <div class="section-header">
      <span class="subtitle">
        {{ contact.subtitle }}
      </span>

      <h2>
        {{ contact.title }}
      </h2>

      <p>
        {{ contact.description }}
      </p>
    </div>

    <div class="contact-content">
      <div class="contact-card">
        <h3>{{ contact.cardTitle }}</h3>

        <div class="contact-card-body">
          <div class="contact-card-column">
            <div class="info">
              <h4>
                <i class="fas fa-map-marker-alt"></i>
                {{ contact.addressLabel }}
              </h4>

              @for (line of contact.address.addressLines; track line) {
                <p>{{ line }}</p>
              }
            </div>
          </div>

          <div class="contact-card-column">
            <div class="info">
              <h4>
                <i class="fas fa-phone"></i>
                {{ contact.phoneLabel }}
              </h4>

              @for (phone of contact.phones; track phone) {
                <p>
                  <strong>{{ phone.label }}:</strong> {{ phone.number }}
                </p>
              }
            </div>

            <div class="info">
              <h4>
                <i class="fas fa-envelope"></i>
                {{ contact.emailLabel }}
              </h4>

              <p>{{ contact.email.emailAddress }}</p>
            </div>
          </div>
        </div>

        @if (booking && booking.id) {
          <a [href]="'#' + booking.id" class="primary-btn">
            {{ contact.buttonText }}
          </a>
        }
      </div>

      <div class="map">
        <iframe
          [src]="contact.address.embedMapUrl | safe: 'resourceUrl'"
          width="100%"
          height="100%"
          style="border: 0"
          loading="lazy"
          allowfullscreen
        >
        </iframe>
      </div>
    </div>
  </div>
</section>
